// extracted by mini-css-extract-plugin
module.exports = {"ExpandArea":"ExpandArea_ExpandArea__1vd6K","open":"ExpandArea_open__2774u","container":"ExpandArea_container__BlOhR","Title":"ExpandArea_Title__2z0Yz"};